import { render, staticRenderFns } from "./activityNBA.html?vue&type=template&id=45384772&scoped=true&external"
import script from "./activityNBA.vue?vue&type=script&lang=js"
export * from "./activityNBA.vue?vue&type=script&lang=js"
import style0 from "./activityNBA.css?vue&type=style&index=0&id=45384772&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45384772",
  null
  
)

export default component.exports